import { matchPath, useParams } from 'react-router-dom';

import { DEFAULT_MODULE } from 'constants/federation';
import { useRemoteModule } from 'hooks/useRemoteModule';
import { Suspense, useMemo } from 'react';
import handleCreateRedirection from 'utils/handleCreateRedirection';
import pathsWithLanguagesCode from 'utils/pathsWithLanguagesCode';

interface RouteResolverProps {
  routes: Record<string, string>;
  versions: Record<string, string>;
}

export function RouteResolver({ routes: allRoutes, versions }: RouteResolverProps) {
  const { '*': routeParams } = useParams();
  const routes = pathsWithLanguagesCode(allRoutes);

  const configRoute = Object.keys(routes).find(
    (pathname: string) => matchPath(pathname, `/${routeParams}`)
  ) || '';
  
  const moduleName = handleCreateRedirection(routeParams, routes[configRoute]);

  console.log('moduleName', moduleName);
  
  const Module = useMemo(() => useRemoteModule(moduleName || DEFAULT_MODULE), [moduleName]);
  const version = useMemo(() => versions[moduleName] || '', [moduleName, versions]);
  
  return (
    <Suspense>
      <Module version={version} />
    </Suspense>
  );
} 
